import { TSDate } from "foundation-ts/tsdate";

export function maskIban(iban?: string): string {
  const clean = iban?.replace(/\s/g, "");
  return `•••• •••• •••• •••• ${clean?.slice(-4)}`;
}
 
export function formatDate(date?: TSDate): string {
  return date?.toString("%d %B %Y") ?? "";
}
 
export function formatAmount(amount: number): string {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(amount);
}
 
export function computeProrata(pricePerYear: number, daysRemaining: number): number {
  return Math.round((pricePerYear * daysRemaining) / 365);
}

export function maskCard(last4: string, brand?: string): string {
  return `${brand ? brand + " " : ""}•••• •••• •••• ${last4}`;
}
